<div class="nova-font-style padding-15">
  <!-- SUMMARY -->
  <div class="row colstyle" *ngIf="(summaryData?.wizardData | json) != '{}'">
    <div class="col s12 m4 l4 xl4 center-align">
      <div class="bold headingtext">SSN</div>
      <div class="bold headingdata">{{summaryData?.wizardData?.empSSN}}</div>
    </div>
    <div class="col s12 m4 l4 xl4 center-align">
      <div class="bold headingtext">Last Name</div>
      <div class="bold headingdata">{{summaryData?.wizardData?.personDetails?.lastName}}</div>
    </div>
    <div class="col s12 m4 l4 xl4 center-align">
      <div class="bold headingtext">Date of Birth</div>
      <div class="bold headingdata">{{summaryData?.wizardData?.personDetails?.dateOfBirth | date: 'MM/dd/yyyy'}}</div>
    </div>
  </div>
  <h2 class="top-padding-15">Enrollment Information</h2>
  <div class="top-margin-5 inline-flex-display" (change)='onEnrollInfoChange()'>
    <div class="left-padding-0">
      <span class="bold">{{config.Question1}}</span>
    </div>
    <div class="left-padding-10 inline-flex-display">
      <input type="radio" id="yesRadio" [(ngModel)]="electType" [value]="'Yes'" name="electType" kendoRadioButton />
      <label class="k-radio-label left-margin-0 right-margin-10" id="elect-text" for="yesRadio">Yes</label>
      <input type="radio" id="noRadio" [(ngModel)]="electType" [value]="'No'" name="electType" kendoRadioButton />
      <label class="k-radio-label left-margin-0" id="elect-text" for="noRadio">No</label>
    </div>
  </div>
  <div>
    <ul class="left-margin-28">
      <li *ngFor="let choice of config.Choices">{{choice}}</li>
    </ul>
  </div>
  <div class="top-margin-15">
    <div class="left-padding-0" *ngIf="isYesSelected">
      <span>{{config.YesSelectionMsg}}</span>
    </div>
    <div class="top-margin-5 inline-flex-display" (change)='onPositionInfoChange()' *ngIf="isNoSelected">
      <div class="left-padding-0">
        <span class="bold">{{config.NoSelectionMsg}}</span>
      </div>
      <div class="left-padding-10 inline-flex-display">
        <input type="radio" id="yesRadio2" [(ngModel)]="positionType" [value]="'Yes'" name="positionType"
          kendoRadioButton />
        <label class="k-radio-label left-margin-0 right-margin-10" id="position-text" for="yesRadio2">Yes</label>
        <input type="radio" id="noRadio2" [(ngModel)]="positionType" [value]="'No'" name="positionType"
          kendoRadioButton />
        <label class="k-radio-label left-margin-0" id="position-text" for="noRadio2">No</label>
      </div>
    </div>
  </div>
  <div class="top-margin-15" *ngIf="isNoPositionSelected">
    <div class="left-padding-0">
      <span class="text-red">{{config.NoMsg}}</span>
    </div>
  </div>
  <div class="top-margin-15" *ngIf="isYesPositionSelected">
    <div class="left-padding-0">
      <form [formGroup]="enrollmentInfoForm">
        <div class="row">
          <div class="col s12 m12 l12 xl12 top-margin-15 left-padding-0">
            <div class="form-group">
              <div class="col s12 m12 l12 xl12">
                <label for="employementDate" class="control-label bold right-margin-10">Employment Start Date<span
                    class="k-required">*</span>:</label>
                <kendo-datepicker id="employementDate" format="MM/dd/yyyy" [min]="min"
                  class="textbox data-selector auto-width width-100p input-auto-width" formControlName="employementDate"
                  placeholder="mm/dd/yyyy" (valueChange)="onEmployementDateChange()">
                </kendo-datepicker>
              </div>
              <div class="col s12 m12 l12 xl12 padding-0">
                <div class="col s12 m12 l5 xl5 top-margin-10">
                  <label for="locationCode" class="control-label bold right-margin-10">Location<span
                      class="k-required">*</span>:</label>
                  <kendo-dropdownlist [defaultItem]="defaultLocation" id="locationCodes" [data]="userLocations"
                    class="width-100p input-auto-width" [textField]="'name'" [valueField]="'code'"
                    formControlName="locationCode" [valuePrimitive]="true"
                    (selectionChange)="selectionChange($event, 'location')">
                  </kendo-dropdownlist>
                </div>
                <div class="col s12 m12 l3 xl3 top-margin-10 right-">
                  <label for="systemCode" id="system-label" class="control-label bold right-margin-10">System<span
                      class="k-required">*</span>:</label>
                  <kendo-dropdownlist id="systemCode" [defaultItem]="defaultSystem" [data]="userSystems"
                    class="width-100p input-auto-width" [textField]="'description'" [valueField]="'code'"
                    formControlName="systemCode" [valuePrimitive]="true"
                    (selectionChange)="selectionChange($event, 'system')">
                  </kendo-dropdownlist>
                </div>
                <div class="col s12 m12 l4 xl4 top-margin-10 right-padding-0 left-padding-0"
                  *ngIf="!isScheduleSearching && (organizationType === 'PGU' || organizationType === 'QST' || organizationType === 'ST') && (selectedFY >= fiscalYear2017)">
                  <label for="paySchedule" id="system-label" class="control-label bold right-margin-10">Pay
                    Schedule<span class="k-required"
                      *ngIf="organizationType === 'PGU' || organizationType === 'QST' || organizationType === 'ST'">*</span>:</label>
                  <kendo-dropdownlist id="paySchedule" [defaultItem]="defaultSchedule" [data]="paySchedulesList"
                    class="width-100p input-auto-width" [textField]="'name'" [valueField]="'payScheduleID'"
                    formControlName="paySchedule" [valuePrimitive]="true"
                    (selectionChange)="selectionPaySchedule($event)">
                  </kendo-dropdownlist>
                </div>
                <span *ngIf="isScheduleSearching" class="k-icon k-i-loading inner"></span>
              </div>
            </div>
          </div>
        </div>
      </form>
      <!-- 10 Month Employee -->
      <div class="top-margin-5 inline-flex-display" (change)='onTenMonthEmpInfoChange()' *ngIf="isTenMonthEmployee">
        <div class="left-padding-0">
          <span class="bold">{{config.Question3}}</span>
        </div>
        <div class="left-padding-10 inline-flex-display">
          <input type="radio" id="yesRadio3" [(ngModel)]="tenMonthEmpType" [value]="'Yes'" name="tenMonthEmpType"
            kendoRadioButton />
          <label class="k-radio-label left-margin-0 right-margin-10" id="position-text" for="yesRadio3">Yes</label>
          <input type="radio" id="noRadio3" [(ngModel)]="tenMonthEmpType" [value]="'No'" name="tenMonthEmpType"
            kendoRadioButton />
          <label class="k-radio-label left-margin-0" id="position-text" for="noRadio3">No</label>
        </div>
      </div>
      <div class="row">
        <div class="col s12 m12 l6 xl6 left-padding-0">
          <div class="padding-75" *ngIf="enrollmentInfoForm.valid && isUploadVisible && (enrollmentInfoForm.getRawValue().systemCode === '6'
      || enrollmentInfoForm.getRawValue().systemCode === '9' || enrollmentInfoForm.getRawValue().systemCode === '3'
      || enrollmentInfoForm.getRawValue().systemCode === '2C')">
            <label class="control-label bold">Upload Employee Job Description:</label>
            <kendo-upload #upload id="enrollement-upload" [multiple]="false" [autoUpload]="false"
              [restrictions]="fileRestrictions" (select)="onSelectEvent($event, upload)"
              (remove)="onRemoveEvent($event)">
              <kendo-upload-messages [select]="'Select a file...'">
              </kendo-upload-messages>
            </kendo-upload>
          </div>
        </div>
        <div class="col s12 m12 l5 xl5 left-padding-0"
          *ngIf="isUploadVisible && summaryData?.wizardData?.enrollmentDetails?.uploadedFileName && (enrollmentInfoForm.getRawValue().systemCode === '6'
          || enrollmentInfoForm.getRawValue().systemCode === '9' || enrollmentInfoForm.getRawValue().systemCode === '3'
          || enrollmentInfoForm.getRawValue().systemCode === '2C')">
          <div class="padding-75 grid-display">
            <label class="control-label bold">Previously Uploaded File:</label>
            <span class="top-margin-10" (click)="downloadUploadedFile(summaryData); summaryData.docClicked=!summaryData.docClicked">
                <a class="clone-link" *ngIf="!summaryData.docClicked">{{summaryData?.wizardData?.enrollmentDetails?.uploadedFileName}}</a>
                <span *ngIf="summaryData.docClicked" class="k-icon k-i-loading inner"></span>
            </span>
        </div>
        </div>
      </div>
    </div>
  </div>
  <div class="stroke-separator"></div>
  <div class="row top-margin-15">
    <div class="col s12 m12 l6 xl6">
      <button type="button" (click)="goToPreviousPage(0)" class="btn btn-fullwidth background-red">
        <span class="k-icon k-i-arrow-chevron-left"></span> Previous
      </button>
    </div>
    <div class="col s12 m12 l6 xl6 align-right" *ngIf="isYesPositionSelected">
      <button kendoButton type="submit" (click)="goToContactInfo(2)" id="save-btn"
        class="btn btn-fullwidth background-red" [disabled]="saveBtnDisable() || displayload || isScheduleSearching">
        <span *ngIf="!displayload">Save and Continue</span>
        <span *ngIf="displayload" class="k-icon k-i-loading inner"></span>
        <span *ngIf="!displayload" class="k-icon k-i-arrow-chevron-right"></span>
      </button>
    </div>
    <div kendoButton class="col s12 m12 l6 xl6 align-right" *ngIf="isNoPositionSelected">
      <button type="button" (click)="startNewEnrollment(0)" class="btn btn-fullwidth background-red">
        Start New Enrollment
      </button>
    </div>
  </div>
</div>